import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, ReplaySubject, Subject, Subscription} from 'rxjs';
import {UiControl} from '../models/uiControl';
import {UIArtefakt, UIArtefaktContainer, UIArtefaktGruppe, UIMenu} from '../models/uiArtefakt';
import {MenuState} from '../models/menuState';
import {Vermittlerdaten} from '../models/vermittlerdaten';
import {VariantenvergleichData} from '../models/variantenvergleichData';
import {AntragBearbeitenData} from '../models/antragBearbeitenData';
import {AntragsannahmeUrlParams} from '../models/urlParams';

@Injectable()
export class EventService {
  public uiControls$ = new ReplaySubject<UiControl>(1);
  public uiControlsNewst$ = new Subject<UiControl>();
  public uiControlsUnmodified$ = new ReplaySubject<UiControl>(1);
  public uiControlsRequestPending$ = new BehaviorSubject<boolean>(false);
  public isDokumentpaketRequestPending$ = new BehaviorSubject<boolean>(false);
  public uiUpdateRequest$ = new Subject<UiControl>();

  public urlParams$ = new ReplaySubject<AntragsannahmeUrlParams>(1);
  public uiArtefaktGruppen$ = new ReplaySubject<Map<string, UIArtefaktGruppe>>(1);
  public validationState$ = new ReplaySubject<Map<string, boolean>>(1);
  public validateSeiteSelected$ = new Subject<string>();

  public menu$ = new ReplaySubject<UIMenu>(1);
  public menuState$ = new ReplaySubject<MenuState>(1);
  public menuItemSelected$ = new BehaviorSubject<string>(null);
  public menuItemRequested$ = new Subject<string>();
  public highestClickedMenuItem$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public navigationButtonClicked$ = new Subject<string>();
  public supressBeforeUnloadDialogButtonClicked$ = new Subject<void>();
  public weiterButtonClicked$ = new Subject<void>();
  public zurueckButtonClicked$ = new Subject<void>();

  public validateAdress$ = new Subject<string>();
  public vermittlerdaten$: BehaviorSubject<Vermittlerdaten> = new BehaviorSubject<Vermittlerdaten>(null);
  public antragsgenerationDatum$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  public antragBearbeiten$: BehaviorSubject<AntragBearbeitenData> = new BehaviorSubject<AntragBearbeitenData>(null);
  public variantenvergleichData$: ReplaySubject<VariantenvergleichData> = new ReplaySubject<VariantenvergleichData>(1);
  public roetelnEnabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public modalDialogGeoeffnet$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public avvEinwilligungImAntrag$: BehaviorSubject<UIArtefakt> = new BehaviorSubject<UIArtefakt>(null);
  public angebotserstellungMoeglichJN$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public vermittlerdatenFuerAvvGesetzt$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public refIdentTouchedOrDirty$: Subject<string> = new Subject<string>();
  public sessionId$: ReplaySubject<string> = new ReplaySubject<string>();
  public visitorId$: ReplaySubject<string> = new ReplaySubject<string>();
  public asyncBerechnung$ = new BehaviorSubject<UIArtefaktContainer>(null);
  public consent$: Observable<{ matomo: boolean }> = new Observable<{ matomo: boolean }>(null);
  public versicherungsbeginn$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private _uiUpdateRequestSubscription: Subscription = Subscription.EMPTY;

  public init() {
    this.menuItemSelected$ = new BehaviorSubject<string>(null);
    this._uiUpdateRequestSubscription.unsubscribe();
    this._uiUpdateRequestSubscription = this.uiControlsNewst$.subscribe(this.uiUpdateRequest$);
  }
}
